export type TaskAction = 'Create' | 'Complete' | 'Reopen' | 'Update' | 'View details';

export type LogGainsightAnalytics = (p: {
  tracker: { name: string; props?: Record<string, unknown> };
}) => void;

export function taskActionEvent(
  action: TaskAction,
  organizationId: string,
  userId: string,
  taskId: string
) {
  return {
    tracker: {
      name: `Task management | Actions | ${action}`,
      props: { organizationId, userId, taskId, timestamp: new Date().toISOString() },
    },
  };
}
